import { filterUndefinedAndEmptyValues, gtmEvent } from '../../utils/gtmEvents';
import { removeAllTagsFromMarkdown } from '../../utils/markdown';
const gtmTrimToggleClick = ({ componentType, model, modelYear, trim, gtmBodyStyle, availabilityFlag, isInventoryVariant, galleryType, }) => {
    let gtmPayload = {};
    let eventName = 'cta_click';
    let ctaType = 'toggle thumbnail';
    let ctaPlacement = 'summary';
    let linkText = 'toggle thumbnail';
    let componentTypeStr = componentType;
    if (isInventoryVariant) {
        eventName = 'dealer_inventory_gallery_toggle';
        ctaType = '';
        ctaPlacement = '';
        linkText = '';
        componentTypeStr = '';
    }
    gtmPayload = {
        event: eventName,
        cta_type: ctaType,
        cta_placement: ctaPlacement,
        link_text: linkText,
        component_type: componentTypeStr,
        model,
        model_year: modelYear,
        trim: removeAllTagsFromMarkdown(trim),
        body_style: gtmBodyStyle,
        availability_flag: availabilityFlag,
        gallery_type: galleryType !== null && galleryType !== void 0 ? galleryType : '',
    };
    const filteredPayload = filterUndefinedAndEmptyValues(gtmPayload);
    gtmEvent(filteredPayload);
};
export default gtmTrimToggleClick;
